import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";
import React from "react";

const HeaderTwo = createSvgIcon(
  <>
    <path d="M11.2857 14H8.42857V8.0813H2.85714V14H0V0.189702H2.85714V5.78591H8.42857V0.189702H11.2857V14Z" />
    <path d="M23 14H13.4952V12.122L17.981 7.36043C18.5968 6.69015 19.0508 6.10524 19.3429 5.60569C19.6413 5.10614 19.7905 4.63189 19.7905 4.18293C19.7905 3.56956 19.6349 3.08898 19.3238 2.74119C19.0127 2.38708 18.5683 2.21003 17.9905 2.21003C17.3683 2.21003 16.8762 2.42502 16.5143 2.85501C16.1587 3.27868 15.981 3.8383 15.981 4.53388H13.219C13.219 3.69286 13.419 2.92457 13.819 2.229C14.2254 1.53342 14.7968 0.989612 15.5333 0.597561C16.2698 0.199187 17.1048 0 18.0381 0C19.4667 0 20.5746 0.341463 21.3619 1.02439C22.1556 1.70732 22.5524 2.67164 22.5524 3.91734C22.5524 4.60027 22.3746 5.29584 22.019 6.00407C21.6635 6.71229 21.054 7.53749 20.1905 8.47967L17.0381 11.79H23V14Z" />
  </>,
  "HeaderTwo"
);

export default HeaderTwo;
